
/**
 * 车辆审核时信息修改
 */
import React, { Component } from 'react';
import { Modal, Form, Input, Row, Col, Switch, Divider, InputNumber, DatePicker, TreeSelect} from 'antd';
import moment from 'moment';

import http from '../../../axios/http';
import validator from '../../../util/validator';
import Loading from '../../ui/Loading';

import messager from '../../ui/messager';
import DictSelect from '../../ui/DictSelect';
import { treeDataConversion, buildTree } from '../../ui/treeData';

import '../../../style/common/uploadImage.css';

const vehicleField = [{
    "text": "创建人",
    "field": "nickname",
    "disabled": true
}, {
    "text": "车架号",
    "field": "vin",
    rules: [
        { required: true, message: '车架号不能为空!' },
        { max: 32, message: '车架号不能超过32个字符！' },
        validator.enNum
    ]
}, {
    "text": "车牌号",
    "field": "plateNo",
    rules: [
        { required: true, message: '车牌号码不能为空!' },
        validator.plateNo
    ]
}, {
    "text": "初登日期",
    "field": "registerDate",
    "date": true,
    rules: [
        { required: true, message: '初登日期不能为空!' },
    ]
}, {
    "text": "品牌型号",
    "field": "brandModel",
    rules: [
        { required: true, message: '品牌型号不能为空!' },
        { max: 64, message: '品牌型号不能超过64个字符！' },
    ]
}, {
    "text": "使用性质",
    "field": "useProperty",
    "select": true,
    "category": "VEHICLE_USE_PROPERTY",
    rules: [
        { required: true, message: '使用性质不能为空!' },
    ]
}, {
    "text": "车主姓名",
    "field": "owner",
    rules: [
        { required: true, message: '车主名称不能为空!' },
        { max: 32, message: '车主名称不能超过32个字符！' },
    ]
}, {
    "text": "客户来源",
    "field": "clientSource",
    "treeSelect": true,
    rules: [
        { required: true, message: '客户来源不能为空!' },
    ]
}, {
    "text": "车主住所",
    "field": "ownerAddress",
    "textarea": true,
    rules: [
        { required: true, message: '车主住所不能为空!' },
        { max: 128, message: '车主住所不能超过128个字符！' },
    ]
}];

const otherField = [ {
    "text": "车辆名称",
    "field": "vehicleName",
    rules: [
        { required: true, message: '车辆名称不能为空!' },
    ]
}, {
    "text": "配置(加装)",
    "field": "detailHighlight",
    rules: [
        { required: true, message: '配置(加装)不能为空!' },
    ]
}, {
    "text": "能源类型",
    "field": "fueltype",
    "select": true,
    "category": "fuelType",
    rules: [
        { required: true, message: '能源类型不能为空!' },
    ]
}, {
    "text": "变速箱类型",
    "field": "gearType",
    "select": true,
    "category": "EVALUATION_GEARBOX_TYPE",
    rules: [
        { required: true, message: '变速箱类型不能为空!' },
    ]
}, {
    "text": "驱动方式",
    "field": "driveMode",
    "select": true,
    "category": "VEHICLE_DRIVING_MODE",
    rules: [
        { required: true, message: '驱动方式不能为空!' },
    ]
},  {
    "text": "表显里程(公里)",
    "field": "mileage",
    "number": true,
    "precision": 0,
    rules: [
        { required: true, message: '表显里程不能为空!' },
    ]
}, {
    "text": "初次登记地",
    "field": "registerLocation",
    rules: [
        { required: true, message: '初次登记地不能为空!' },
    ]
}, {
    "text": "过户次数",
    "field": "transferTimes",
    "number": true,
    "precision": 0,
    rules: [
        { required: true, message: '过户次数不能为空!' },
    ]
}, {
    "text": "钥匙数量",
    "field": "keyNum",
    "number": true,
    "precision": 0,
    rules: [
        { required: true, message: '钥匙数量不能为空!' },
    ]
}, {
    "text": "证件",
    "field": "certificate",
    "multySelect": true,
    "category": "VEHICLE_CERTIFICATE",
    rules: [
        { required: true, message: '证件不能为空!' },
    ]
}, {
    "text": "交强险有效期",
    "field": "mandatoryInsuranceDate",
    "date": true
}, {
    "text": "商业险有效期",
    "field": "commerciaInsuranceDate",
    "date": true
}, {
    "text": "出厂日期",
    "field": "productionDate",
    "date": true
}, {
    "text": "年检有效期",
    "field": "examinationDate",
    "month": true
}
, {
    "text": "是否按揭",
    "field": "mortgage",
    "radio": true,
    rules: [
        { required: true, message: '是否按揭不能为空!' },
    ]
}
, {
    "text": "回收配件",
    "field": "recycle",
    "textarea": true,
    rules: [
        { max: 256, message: '回收配件不能超过256个字符！' },
    ]
}, {
    "text": "特殊情况说明",
    "field": "specialMark",
    "textarea": true,
    rules: [
        { max: 256, message: '特殊情况说明不能超过256个字符！' },
    ]
}
, {
    "text": "是否展示检测信息",
    "field": "showDetection",
    "radio": true,
    rules: [
        { required: true, message: '是否展示检测信息不能为空!' },
    ]
}
, {
    "text": "备注",
    "field": "mark",
    "textarea": true,
    rules: [
        { max: 256, message: '备注不能超过256个字符！' },
    ]
}];

class AuctionAuditEditForm extends Component {
    state = {
        loadingVisible: false,
        dictText: {},
        multyDict: [],
        dictData:[],
    }
    
    componentDidMount() {
        this.initDictState();
    }

    initDictState = () => {
        http.post({
            url: "/dict/findDict",
            data: {"category": "VEHICLE_CERTIFICATE"},
            success: (res) => {
                this.setState({dictData: res});
            }
        });
        //获取客户来源数据
        http.post({
            url: '/dict/findDict',
            data: { category: "VEHICLE_CLIENT_SOURCE" },
            success: (res) => {
                res = res == null ? [] : res;
                //把客户来源字典重构为符合treeSelect格式要求的树形结构
                res = buildTree(res);
                treeDataConversion(res, true);
                //把res的code设置为name[code]，为了能用treeSelect的搜索
                this.setState({ clientSourceData: res});
            }
        });
    }

    save = () => {
        const form = this.props.form;
        const dictData = this.state.dictData;
        form.validateFields((err, values) => {
            if (err) {
                return;
            }
            this.setState({ loadingVisible: true });

            values["id"] = this.props.editData["id"];

            if (values["registerDate"] != null) {
                values["registerDate"] = values["registerDate"].format("YYYY-MM-DD");
            }

            if (values["productionDate"] != null) {
                values["productionDate"] = values["productionDate"].format("YYYY-MM-DD");
            }

            if (values["examinationDate"] != null) {
                values["examinationDate"] = values["examinationDate"].format("YYYY-MM");
            }

            if (values["mandatoryInsuranceDate"] != null) {
                values["mandatoryInsuranceDate"] = values["mandatoryInsuranceDate"].format("YYYY-MM-DD");
            }

            if (values["commerciaInsuranceDate"] != null) {
                values["commerciaInsuranceDate"] = values["commerciaInsuranceDate"].format("YYYY-MM-DD");
            }
            values["mortgage"] = values["mortgage"] ? 1 : 0;
            values["showDetection"] = values["showDetection"] ? 1 : 0;
            //设置证件
            let certificateNameArray = [];
            values["certificate"].forEach((code, index) => {
                dictData.forEach((dict) => {
                    if (code === dict.code) {
                        certificateNameArray.push(dict.name)
                    }
                })
            })

            http.post({
                url: '/auction/web/audit/update',
                data: values,
                success: (res) => {
                    let editData = this.props.editData;
                    let fields = vehicleField.concat(otherField);
                    for(let i in fields){
                        editData[fields[i]["field"]] = values[fields[i]["field"]];
                        if(fields[i]["select"] || fields[i]["treeSelect"]){
                            let dictText = this.state.dictText[fields[i]["field"]];
                            if(dictText != null){
                                editData[fields[i]["field"]+"Str"] = dictText;
                            }
                        }
                    }
                    //设置证件
                    editData["certificateStr"] = certificateNameArray.join(",");
                    this.props.onCancel();
                    messager.notify("保存成功！");
                    this.props.successCallback();
                    this.setState({ loadingVisible: false });
                },
                error: (res) => {
                    messager.alert(res, "异常", "error");
                    this.setState({ loadingVisible: false });
                }
            });
        });
    };

    transferData = (res, field) => {
        let value = res[field];
        for (let key in value) {
            res[field + "." + key] = value[key];
        }
        delete res[field];
    }

    createDom = (item, index, colLength) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let labelCol = colLength === 1 ? 10 : 4;
        let wrapperCol = colLength === 1 ? 14 : 20;
        let itemDom = (
            <Form.Item key={index} label={item.text + "："} labelCol={{ span: labelCol }} wrapperCol={{ span: wrapperCol }}>
                {
                    getFieldDecorator(item.field, {
                        rules: item.rules,
                        initialValue: item.date ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                        : item.month ? (editData[item.field] == null || editData[item.field] === "" ? null : moment(editData[item.field]))
                            : item.radio ? editData[item.field] === 1
                            : item.multySelect ? (editData[item.field] == null || editData[item.field] === "" ? null : editData[item.field].toString().split(","))
                                : editData[item.field],
                        valuePropName: item.radio ? 'checked' : 'value'
                    })(
                        item.number ?
                            <InputNumber precision={item.precision} min={0} max={99999999} style={{ width: '100%' }} />
                            : item.radio ? <Switch checkedChildren="是" unCheckedChildren="否" />
                                : item.select ?
                                    <DictSelect category={item.category} onSelect={this.onSelect.bind(this, item.field)} />
                                    : item.multySelect ?
                                        <DictSelect mode="multiple" category={item.category} /> 
                                        : item.treeSelect ?
                                        <TreeSelect multiple={false} treeData={this.state.clientSourceData}  onSelect={this.onTreeSelect.bind(this, item.field)} treeDefaultExpandAll={false} showSearch={false} />
                                        : item.date ? <DatePicker style={{ width: '100%' }} />
                                        : item.month ? <DatePicker.MonthPicker style={{ width: '100%' }} />
                                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                                : <Input disabled={item.disabled} />
                    )
                }
            </Form.Item>
        );
        return itemDom;
    };

    create2Col = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i += 2) {
            let item = (<Row key={i}>
                <Col span={11}>
                    {this.createDom(data[i], "1" + i, 1)}
                </Col>
                <Col span={11} offset={2}>
                    {(i + 1) < data.length ? this.createDom(data[i + 1], "1" + i, 1) : ''}
                </Col>
            </Row>);
            dom.push(item);
        }
        return dom;
    }

    create1Col = (data) => {
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = this.createDom(data[i], "2" + i, 2);
            dom.push(item);
        }
        return dom;
    }

    onSelect = (field, dict) => {
        let dictText = this.state.dictText;
        dictText[field] = dict["name"];
        this.setState({ dictText: dictText });
    }

    onTreeSelect = (field, value, node, extra) => {
        let dictText = this.state.dictText;
        dictText[field] = node.props.name;
        this.setState({ dictText: dictText });
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                width={900}
                visible={visible}
                title="车辆信息编辑"
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => {
                    this.props.form.resetFields();
                    this.setState({ dictText: {} })
                }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Divider orientation="left">基本信息</Divider>
                    {this.create2Col(vehicleField)}
                    <Divider orientation="left">其他信息</Divider>
                    {this.create2Col(otherField)}
                </Form>
                <Loading
                    visible={this.state.loadingVisible}
                    message="正在保存"
                />
            </Modal>
        );
    }
}

const AuctionAuditEdit = Form.create()(AuctionAuditEditForm);

export default AuctionAuditEdit;